import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from '@phosphor-icons/react';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="hb-bg">
      <div style={{ width: '100%' }} className="min-h-screen">
        {/* Header */}
        <header className="hb-header sticky top-0 z-50">
          <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src="/harperbids-logo.png" alt="HarperBids" className="h-10 hb-logo-glow" />
              <div>
                <h1 className="text-lg font-bold font-heading" style={{ color: 'var(--gold-light)' }}>HARPERBIDS</h1>
                <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Privacy Policy</p>
              </div>
            </div>
            <button
              data-testid="privacy-back-button"
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
              style={{ background: 'rgba(201,206,211,0.1)', border: '1px solid rgba(201,206,211,0.2)', color: 'var(--gold)' }}
            >
              <ArrowLeft size={14} weight="bold" />
              Back
            </button>
          </div>
        </header>

        {/* Content */}
        <main className="max-w-4xl mx-auto px-6 pt-10 pb-20">
          {/* Title */}
          <div className="flex items-center gap-4 mb-3">
            <ShieldCheck size={32} weight="duotone" style={{ color: 'var(--gold)' }} />
            <h1 className="text-3xl font-bold font-heading" style={{ color: 'var(--gold-light)' }}>Privacy Policy</h1>
          </div>
          <p className="text-sm mb-10" style={{ color: 'var(--text-muted)' }} data-testid="privacy-effective-date">
            Effective Date: April 14, 2026
          </p>

          {/* Policy Body */}
          <div className="hb-glass-strong space-y-8" data-testid="privacy-policy-content">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              HarperBids is operated by Alpha 3 Group LLC. We respect your privacy.
            </p>

            {/* Information We Collect */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>Information We Collect</h2>
              <ul className="space-y-2 pl-5" style={{ listStyleType: 'disc' }}>
                <li className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>Account information: name, email, phone, company details</li>
                <li className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>Profile information: services offered, project types, location</li>
                <li className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>Communication data between users</li>
              </ul>
            </section>

            {/* How We Use Your Information */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>How We Use Your Information</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                We use your data to match you with compatible contractors or building owners, manage your account, and improve our service.
              </p>
            </section>

            {/* Sharing Your Information */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>Sharing Your Information</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                We do not sell your personal data. Your profile is only visible to other verified users on the platform.
              </p>
            </section>

            {/* Your Rights */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>Your Rights</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                You may request to delete your account and data at any time by contacting{' '}
                <a href="mailto:admin@harperbids.com" className="font-semibold" style={{ color: 'var(--gold)' }} data-testid="privacy-email-rights">admin@harperbids.com</a>.
              </p>
            </section>

            {/* Cookies and Tracking */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>Cookies and Tracking</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                We use cookies to keep you logged in and improve your experience.
              </p>
            </section>

            {/* Contact */}
            <div className="pt-4" style={{ borderTop: '1px solid var(--border-subtle)' }}>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                For questions, contact:{' '}
                <a href="mailto:admin@harperbids.com" className="font-semibold" style={{ color: 'var(--gold)' }} data-testid="privacy-email-contact">admin@harperbids.com</a>
              </p>
            </div>

            {/* Company */}
            <p className="text-sm font-semibold" style={{ color: 'var(--text-muted)' }}>
              Alpha 3 Group LLC
            </p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
